import React from 'react';

import Header from 'components/header/Header';
import { Box } from '@mui/material';

const Layout = ({ children }) => {
  return (
    <Box className={'appLayout'}>
      <Header />
      <Box className="layoutChildren">{children}</Box>
    </Box>
  );
};

export default Layout;
